<template>
   <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 required"> {{ $t('country') }} </label>
        <app-input 
            class="col-md-8 mt-2 pt-1" 
            :placeholder="$t('select_country_phd')"
            type="advance-search-select" 
            fetch-url="/countries/serverside/selectable-name"
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5" 
        />
        </div>
</template>
 
<script>
    export default {
        name: 'CustomerCountry',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>